import { apiRequest } from './base'

export interface EmailDefaultOption {
  connectionId: string
  provider: string
  displayName: string
}

export interface CalendarDefaultOption {
  calendarId: string
  connectionId: string
  provider: string
  accountDisplayName: string
  name: string
  isPrimary: boolean
  isWritable: boolean
}

export interface DefaultsResponse {
  defaultEmailConnectionId: string | null
  defaultCalendarId: string | null
  emailOptions: EmailDefaultOption[]
  calendarOptions: CalendarDefaultOption[]
}

export async function getDefaults(): Promise<DefaultsResponse> {
  return apiRequest<DefaultsResponse>('/settings/defaults')
}

export async function updateDefaults(
  patch: { defaultEmailConnectionId?: string | null; defaultCalendarId?: string | null },
): Promise<DefaultsResponse> {
  return apiRequest<DefaultsResponse>('/settings/defaults', {
    method: 'PATCH',
    body: JSON.stringify(patch),
  })
}
